export default {
    name: 'Quotes',
    data: () => ({
        quotationMarks: `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/quotation-marks.svg`,
        quotes: [
            {
                image: '',
                text:
                    'Uma estrutura muito bem organizada e sobretudo humanizada. Uma solução com ampla capilaridade, tanto de apresentação de propostas quanto como a setorização dessas demandas. Uma plataforma que visa eficiência e respostas objetivas aos clientes e fornecedores.',
                name: 'Cláudio Sansevero',
                location: 'Synergia Soluções em Engenharia'
            },
            {
                image: '',
                text:
                    'Graças a Engelink consegui sair do vermelho! Excelente atendimento, sempre sanaram minhas dúvidas.',
                name: 'Edvaldo Ramos',
                location: 'K.E.N Engenharia'
            },
            {
                image: '',
                text:
                    'O perfil dos meus clientes chegou a outro patamar. Eu estava escondido na Zona Oeste e agora estou ficando conhecido no resto do Rio de Janeiro! Jamais teria contato do comprador do Maracanã se não fosse a Engelink!',
                name: 'Ademilson Santos',
                location: 'ADSO Engenharia'
            }
        ]
    }),
    created() {
        this.quotes = this.quotes.map(quote => {
            return {
                image: `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/${quote.location}.jpeg`,
                text: quote.text,
                name: quote.name,
                location: quote.location
            };
        });
    }
};
